import React, { useEffect, useState } from 'react';
import { message, Col, Row, Modal, Button, Space } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import { getPortQualityReportInfo } from './api';
import Index from './component/quality/index';
import { useHistory } from "react-router-dom";

import './style.less';

const handling_opinion_type_config = ['', '龙头处理', '运到SVC大仓', '其他', '正常进行下阶段'];

export default function PortQualityReport() {
  const { id } = useParams();
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentOptions, setCurrentOptions] = useState({});
  const history = useHistory();
  useEffect(() => {
    setLoading(false);
    async function portQualityReportInfo() {
      const { data: { code, msg, data } } = await getPortQualityReportInfo(({ id }));
      if (+code === 0) {
        setInfo(data);
      } else {
        message.error(msg);
      }
      setLoading(true);
    }
    portQualityReportInfo();
  }, [id]);

  const showModal = (options = {}) => {
    setCurrentOptions(options);
    setModalVisible(true);
  };


  const handleOk = () => {
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  return (
    <div className='quality-report-container'>
      <Space className='mb-20' split={<RightOutlined />}>
        <Link to={{ pathname: '/basic/user/order' }}>我的采购单</Link>
        <span>订单号：{info.order_no}</span>
        <span>查看质检记录</span>
      </Space>
      {
        loading ? <>
          <div className='port-quality-report-base'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className='port-quality-report-title'>基本信息</div>
              <Button type='primary' onClick={() => { history.push(`/qualityPrint/${id}?print=true`); }}>导出</Button>
            </div>
            <Row className='port-quality-report-item'>
              <Col span={8}>批次号：{info?.base?.bit_no}</Col>
              <Col span={8}>柜号：{info?.base?.container_no}</Col>
              <Col span={8}>砍果时间：{info?.extends?.pick_start_date}</Col>
              <Col span={8}>包装时间：{info?.extends?.label_pack_date}</Col>
              {+info?.category !== 6 ? <Col span={8}>原柜是否查验：{info?.base?.original_cabinet_inspection}</Col> : null}
              <Col span={8}>质检时间：{info?.base?.quality_testing_time}</Col>
              <Col span={8}>质检流程类型：{+(info?.type) === 1 ? '倒柜质检' : '原柜质检'}</Col>
            </Row>
            {
              +info?.category !== 6 ?
                <>
                  {info?.base?.car_list?.map((item, idx) => {
                    return <div key={idx}>
                      <Row className='port-quality-report-item'> <Col span={8}><span style={{ 'fontWeight': 'bold' }}>车辆{idx + 1}</span></Col></Row>
                      <Row className='port-quality-report-item'>
                        <Col span={8}>
                          <div>车头图片/司机图片/驾驶证</div>
                          <div className='port-quality-report-item-imgs'>
                            {(item?.car_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                          </div>
                        </Col>
                        <Col span={8}>
                          <div>风口图片</div>
                          <div className='port-quality-report-item-imgs'>
                            {(item?.tuyere_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                          </div>
                        </Col>
                        <Col span={8}>
                          <div>预冷设置温度：{item?.precooling_temperature?.temperature} ℃</div>
                          <div className='port-quality-report-item-imgs'>
                            {(item?.precooling_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                          </div>
                        </Col>
                      </Row>
                      <Row className='port-quality-report-item'>
                        <Col span={8}>
                          <div>预冷出风温度：{item?.out_wind_temperature?.temperature} ℃</div>
                          <div className='port-quality-report-item-imgs'>
                            {(item?.out_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                          </div>
                        </Col>
                        <Col span={8}>
                          <div>预冷回风温度：{item?.in_wind_temperature?.temperature} ℃</div>
                          <div className='port-quality-report-item-imgs'>
                            {(item?.in_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                          </div>
                        </Col>
                        <Col span={8}>
                          <div>排水口是否正常：{item?.drain?.is_normal}</div>
                          <div className='port-quality-report-item-imgs'>
                            {(item?.drain?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                          </div>
                        </Col>
                      </Row>
                      <Row className='port-quality-report-item'>
                        <Col span={8}>
                          <div>IOT设备装车照片</div>
                          <div className='port-quality-report-item-imgs'>
                            {(item?.iot_equipment?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                          </div>
                        </Col>
                        {
                          +info?.category === 1 ? <Col span={8}>
                            <div>发车时间：{item.departure_time}</div>
                          </Col> : null
                        }
                      </Row>
                    </div>;
                  })
                  }
                </>
                : <>
                  <Row className='port-quality-report-item'>
                    <Col span={8}>
                      <div>出风温度：{info?.base?.out_wind_temperature?.temperature}℃</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.base?.out_wind_temperature?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                    <Col span={8}>
                      <div>回风温度：{info?.base?.in_wind_temperature?.temperature}℃</div>
                      <div className='port-quality-report-item-imgs'>
                        {(info?.base?.in_wind_temperature?.videos || []).filter(item => item).map((item, index) => <video key={index} width="70" height="70" className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'video' })}><source src={item} /></video>)}
                        {(info?.base?.in_wind_temperature?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                      </div>
                    </Col>
                  </Row>
                </>
            }
          </div>
          {
            +info?.category === 1 ? <>
              <div className='port-quality-report-base'>
                <div className='port-quality-report-title'>开柜质检</div>
                <Row className='port-quality-report-item'>
                  <Col span={8}><div>运输方式：{info?.open_quality?.transport_action_sheet}</div></Col>
                </Row>
                <Row className='port-quality-report-item'>
                  <Col span={8}>
                    <div>箱标签图片</div>
                    <div className='port-quality-report-item-imgs'>
                      {(info?.open_quality?.box_label_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                    </div>
                  </Col>
                </Row>
                <Row className='port-quality-report-item'>
                  <Col span={8}>
                    <div>原柜车头图片</div>
                    <div className='port-quality-report-item-imgs'>
                      {(info?.open_quality?.original_container_truck_head_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div>原柜果心温度：{info?.open_quality?.original_container_core?.temperature} ℃</div>
                    <div className='port-quality-report-item-imgs'>
                      {(info?.open_quality?.original_container_core?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div>原柜开柜味道：{info?.open_quality?.odor_upon_container_opening}</div>
                  </Col>
                  <Col span={8}>
                    <div>原柜风口图片</div>
                    <div className='port-quality-report-item-imgs'>
                      {(info?.open_quality?.original_container_tuyere_pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div>原柜设置温度：{info?.open_quality?.original_container_precooling_temperature?.temperature} ℃</div>
                    <div className='port-quality-report-item-imgs'>
                      {(info?.open_quality?.original_container_precooling_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div>原柜出风温度：{info?.open_quality?.original_container_out_wind_temperature?.temperature} ℃</div>
                    <div className='port-quality-report-item-imgs'>
                      {(info?.open_quality?.original_container_out_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div>原柜回风温度：{info?.open_quality?.original_container_in_wind_temperature?.temperature} ℃</div>
                    <div className='port-quality-report-item-imgs'>
                      {(info?.open_quality?.original_container_in_wind_temperature?.pictures || []).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => showModal({ item, type: 'image' })} src={item} alt='' />)}
                    </div>
                  </Col>
                </Row>
              </div>
            </> : null
          }
          <Index info={info?.container_last} category={info?.category} currentKey='container_last' showModal={showModal}></Index>
          {
            (+info?.type === 1) && <>
              <Index info={info?.container_middle} category={info?.category} currentKey='container_middle' showModal={showModal}></Index>
              <Index info={info?.container_head} category={info?.category} currentKey='container_head' showModal={showModal}></Index>
            </>
          }

          {
            info?.handling_opinion_type ? <div className='port-quality-report-base'>
              <div className='port-quality-report-title'>卖方处理意见</div>
              <div className='handling-opinion-item'>{handling_opinion_type_config[+info?.handling_opinion_type]}</div>
              <div className='handling-opinion-item'>{info?.handling_opinion_desc}</div>
            </div> : null
          }

        </> : null
      }
      {
        modalVisible && <Modal open={true} onOk={handleOk} onCancel={handleCancel} footer={null} centered>
          <div className='port-quality-report-modal-content'>
            {(currentOptions?.type === 'image') && <img className='port-quality-report-modal-camera' src={currentOptions?.item} alt='' />}
            {(currentOptions?.type === 'video') && <video className='port-quality-report-modal-camera' controls controlsList="nofullscreen nodownload noremoteplayback" disablePictureInPicture><source src={currentOptions?.item} /></video>}
          </div>
        </Modal>
      }
    </div >
  );
}
